<template>
  <div class="iv-declaration-signing iv-p-b-40">
    <div class="iv-main-width">
      <List
        v-if="list.length"
        :showPage="true" 
        :total="total" 
        :list="list"
        :current="currentPage"
        :pageSize="pageSize"
        @on-detail="detailPage" 
        @on-change="changePage"
        @on-page-size-change="changePageSize">
      </List>
      <NoData v-if="!list.length"></NoData>
    </div>
    <!-- <Spin size="large" fix v-if="spinShow"></Spin> -->
  </div>
</template>

<script>
import NoData from '@/components/no-data'
import IconFont from '@/components/iconfont'
import List from '@/components/declaration-signList'
import { oneselfList } from './interface/index.js'

export default {
  data () {
    return {
      list: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
    }
  },
  created () {
    this.getSelfList()
  },
  methods: {
    //获取操守宣言列表
    getSelfList () {
      oneselfList({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then(data => {
        this.list = data.data
        this.total = data.count
      })
    },
    detailPage (item, type) {
      this.$router.push({
        name: 'declarationSignDetail',
        query: {
          scopeId: item.scopeId,
          isSign: item.isSign,
          type: type == 'edit' ? 'edit' : 'see'
        }
      })
    },
    changePage (page) {
      this.currentPage = page
      this.getSelfList()
    },
    changePageSize (page) {
      this.pageSize = page
      this.getSelfList()
    }
  },
  components: {
    List,
    NoData,
    IconFont
  }
}
</script>

<style lang="scss" scoped>
.iv-declaration-signing {
  min-height: 100%;
  background-color: #fff;
}
</style>
